<script setup lang="ts"></script>

<template>
    <div class="px-2 sm:px-4 lg:px-6 mx-auto">
        <slot></slot>
    </div>
</template>

<style scoped></style>
